/**
 * @desc sku销售预测-审批
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlmSkuForecastApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/forecast/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
